<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title">Adatbázis adatai</h5>
			<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
		</div>
		<div class="modal-body">
			<%- include('/ui/form', {
				params: [ 'company_db', company_db ],
				fields: [
					{ type: 'row', fields: [
						{ type: 'col', fields: [
							{ type: 'fieldset', title: 'Alapadatok', fields: [
								{
									type: 'text',
									name: 'db_name',
									title: 'Név',
									attributes: (company_db.id !== null) ? {
										readonly: true
									} : {},
								},
								{
									type: 'text',
									name: 'webapi_authcode',
									title: 'API kulcs'
								},
								{
									type: 'checkbox',
									name: 'sandbox',
									title: '',
									description: 'Teszt adatbázis'
								},
								{
									type: 'select',
									name: 'company_id',
									title: 'Cég',
									params: {
										maxItems: 1,
										options: companies.data,
										valueField: 'id',
										labelField: 'name',
										searchField: [ 'tax_number', 'name' ],
										render: {
											item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
											option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
										}
									},
									unset_value: null
								},
								{
									type: 'html',
									content: '<hr />'
								},
								{
									type: 'select',
									name: 'service_partner_id',
									title: 'Szerviz partner',
									params: {
										maxItems: 1,
										options: companies.data.filter(x => x.service_partner == 1),
										valueField: 'id',
										labelField: 'name',
										searchField: [ 'tax_number', 'name' ],
										render: {
											item: (item, esc) => `<div>${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`,
											option: (item, esc) => `<div class="option">${esc(item.name)}<br /><small>${esc(item.tax_number)}</small></div>`
										}
									},
									unset_value: null
								}
							]}
						]}
					]}
				]
			}) %>
		</div>
		<div class="modal-footer justify-content-between">
			<div>
				<div class="dropup float-start me-1">
					<button class="btn btn-dark" data-bs-toggle="dropdown" data-bs-auto-close="outside"><i class="fa fa-fw fa-caret-up"></i></button>
					<ul class="dropdown-menu">
						<li><button type="button" class="dropdown-item py-2" onclick="Anvil.page.modal.close(); Anvil.exec('company/modal_edit', <%- company_db.company_id %>)"><i class="fa fa-fw fa-building me-3"></i><%- company_db.company_name %></button></li>
						<li><button type="button" class="dropdown-item py-2 disabled"><i class="fa fa-fw fa-database me-3"></i><%- company_db.db_name %></button></li>
					</ul>
				</div>
				<button type="button" class="btn btn-dark" style="color:tan;" onclick="Anvil.page.modal.issue()"><i class="fa fa-briefcase me-2"></i>Új munkalap</button>
			</div>
			<button type="button" class="btn btn-primary" onclick="Anvil.page.modal.save()"><i class="fa fa-save me-2"></i>Mentés</button>
		</div>
	</div>
</div>
<script>
Anvil.page.modal = Object.assign(Anvil.page.modal, {

	issue () {
		Anvil.page.modal.close()
		Anvil.exec('issue/modal_edit', null, {
			link: 'database',
			company_id: Anvil.page.modal.company_db.company_id,
			company_db_id: Anvil.page.modal.company_db.id
		})
	},

	async save () {
		const res = await Anvil.exec('c_order/company_db/action_save', Anvil.page.modal.company_db)

		if (res === true) {

			// Refresh list
			if ('refresh' in Anvil.page) {
				Anvil.page.refresh()
			}

			// Focus on company
			/*
			let grid = Anvil.models.components.Grid.find('#company_db_grid')
			grid.select(grid.list.getById(Anvil.page.modal.company_db.id), true)
			*/

			// Close modal
			Anvil.page.modal.close()
		}
	}
})
</script>
